import { Button } from '../../../../button/block';
import clsx from 'clsx';

import style from './style.module.scss';
import { Alert } from '@mui/material';

export const SubmitButton = ({ buttonText, successMsg, disabled = false, setIsSubmitted = null, ...props }) => {
    return (
        <div {...props} className={clsx(style.block, props.className)}>
            <Button
                onClick={() => setIsSubmitted && setIsSubmitted(true)}
                isSubmit={true}
                text={buttonText}
                className={clsx(disabled && style.disabled)}
                disabled={disabled}
                tagName={'button'}
                type="filled"
            />
            {successMsg && (
                <Alert severity="success" className={clsx(style.alert, style.success)}>
                    {successMsg}
                </Alert>
            )}
        </div>
    );
};

export default SubmitButton;
